/* Feature detection */
let passiveIfSupported: any = false;

try {
  window.addEventListener("test", null, 
	Object.defineProperty(
	  {}, 
	  "passive", 
	  {
		get: function() { passiveIfSupported = { passive: false }; }
	  }
	)
  );
} catch(err) {}

export default passiveIfSupported;